import {
  responsiveMediaFragment
} from './mediaFragments.gql'
import {
  localeFragment
} from './fragments.gql'

export default `query EmailSignupModalQuery($locale: SiteLocale) {
  emailSignupModal(${localeFragment}) {
    ${responsiveMediaFragment('image')}
    modalTitle
    description
    productionPromoIds
    stagingPromoIds
    prodShopify
    stagingShopify
    discountMessage
  }
}`
